
// src/web/components/user-timeline-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/user-timeline-page'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import Diary from './diary.jsx'
import DiaryContent from './diary-content.jsx'
import UserMonthlySummaryPage from './user-monthly-summary-page'
import { InfiniteScroll, InviewSensor } from './infinite-scroller';
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import Avatar from 'react-toolbox/lib/avatar'
import { Panel } from 'react-toolbox/lib/layout'
import twoColumnLayoutTheme from './themes/two-column-layout.css'
import profileTheme from './themes/profile.css'
import diaryTheme from './themes/diary.css'
import moment from 'moment'


class UserTimelinePage extends React.Component {
  updateFavoriteUser = ()=> this.props.updateFavoriteUser(this.props, !this.props.isFavorite)
  updateBlockUser = ()=> this.props.updateBlockUser(this.props.targetUser, !this.props.isBlock)

  onReplyScrollFrom = (offset)=> {
    //COMMENT_FORM_HEIGHTはコメントフォームの高さ
    const COMMENT_FORM_HEIGHT = 222
    //返信コメントへの返信の場合、コメントフォームまでスクロールする
    this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT)
  }

  openMonthlySummary = () => typeof this.props.targetUser.is_member != 'undefined' ?  this.props.updateUI({ is_summary: true }) : this.props.notIsMember()

  render() {
    const {
      t,
      ui,
      isFetching,
      isFetchFailed,
      hasMore,
      diaries,
      user,
      targetUser,
      group,
      fetchDiaries,
      isFavorite,
      isBlock,
      updateUI,
      openChatRoom,
      openUserSettingsPage,
      updateFavoriteUser,
      updateBlockUser,
      likeConfig,
      rightSidePage,
      notIsMember,
    } = this.props

    return (
      <RightSidePage title={targetUser && targetUser.name || null} innerRef={(c)=> this.rightSidePage = c}
          icon={!targetUser && "person"}
          image={targetUser && targetUser.icon_image.thumb_url}
          rightAction={
            targetUser && !targetUser.dummy_user && targetUser.user_id != user.user_id &&
              <Button theme={diaryTheme} className="profile" ripple={false} neutral ={false}
                icon={<FontIcon value={isFavorite && 'flag' || 'outlined_flag'} style={isFavorite && { color: '#FFCC00' } || undefined}/>}
                onClick={this.updateFavoriteUser}
                label={isFavorite ? t('label:フォロー中') : t('label:お気に入りに追加')}/>
          }>
        {!isFetchFailed && !diaries && isFetching &&
          <Loading />
        }
        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 56 }}>
          { ブロック機能をeableする場合にはこのコードを使用
            <Button theme={diaryTheme} className="block" ripple={false} neutral ={false}
              icon={<FontIcon style={{ fontSize: 12 }} value={isBlock && 'do_not_disturb_on' || 'block'}/>}
              label={isBlock ? t('label:ブロック解除') : t('label:ブロック')}
              onClick={this.updateBlockUser}/>}
        </div> */}
        <div style={{ display: 'flex', marginBottom: 10 }}>
          <Avatar theme={profileTheme} icon={!targetUser && "person"} image={targetUser && targetUser.icon_image.thumb_url} />
          <div style={{ marginTop: 10, marginLeft: 15 }}>
            {targetUser &&
              <div className={profileTheme.information_wrap}>
                <div className={profileTheme.information_item}><div>{t('label:社員番号')}:</div><span> {targetUser.employment_number}</span></div>
                <div className={profileTheme.information_item}><div>{t('label:部署')}:</div><span> {targetUser.department && targetUser.department.name || ''}</span></div>
                <div className={profileTheme.information_item}><div>{t('label:誕生日')}:</div><span> {targetUser.birthday && moment(targetUser.birthday).format('MM月 DD日') || ''}</span></div>
              </div>
            }
            {group && targetUser && !targetUser.dummy_user &&
            <Button raised primary　theme={diaryTheme} className="profile"
              icon={<FontIcon value='check_box' />}
              onClick={this.openMonthlySummary}
              label={t('label:日報提出状況')} />}
            {targetUser && !targetUser.dummy_user && targetUser.user_id != user.user_id && 
            <Button raised theme={diaryTheme} className="chat"
              icon={<FontIcon value='comment' />}
              onClick={() => openChatRoom(this.props)}
              label={t('label:チャットをする')} /> }
            {targetUser && !targetUser.dummy_user &&  targetUser.user_id == user.user_id &&
              <Button raised　theme={diaryTheme} className="profile"
                icon={<FontIcon value='edit' style={{ color: 'black' }} />}
                onClick={() => openUserSettingsPage()}
                label={t('label:プロフィールを編集')}/>}
          </div>
        </div>
        {!isFetchFailed && targetUser && targetUser.description && 
          <DiaryContent　profile component='div' content={targetUser.description} />
        }
        {!isFetchFailed &&
          <InfiniteScroll pageStart={0}
              hasMore={hasMore && !isFetchFailed}
              initialLoad={false}
              loadMore={()=> !isFetching && fetchDiaries(this.props)}
              loader={
                diaries && <Loading />
              }
              useWindow={false} >
            {diaries && diaries.map((diary)=> 
              <Diary key={diary.diary_id} diary={diary} group={group} user={user} onReplyScrollFrom={this.onReplyScrollFrom} likeConfig={likeConfig} openSidePage={rightSidePage} isBlockDisable={true} isReviewButtonDisplay={false}/>
            )}
          </InfiniteScroll>
        }
        {!isFetchFailed && diaries && diaries.length == 0 && !hasMore &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {t('label:投稿がありません')}
          </div>
        }
        {!isFetchFailed && diaries && diaries.length > 0 && !hasMore &&
          <div style={{ fontSize: '80%', padding: '0 20px', color: '#999' }}>{t('label:一番最後の投稿です')}</div>
        }
        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:投稿の取得に失敗しました')}</div>
        }
        {group && targetUser && !targetUser.dummy_user &&
          <div>
            <UserMonthlySummaryPage
                group={group}
                currentUser={user}
                user={targetUser}
                onClose={()=> updateUI({ is_summary: false })}
                open={ui.is_summary} />
          </div> }       
      </RightSidePage>
    )
  }
}

export const RawUserTimelinePage = UserTimelinePage
export default connect(UserTimelinePage)



// WEBPACK FOOTER //
// ./src/web/components/user-timeline-page.jsx